<div id="not-found" class="container h-100 d-flex justify-content-center align-items-center">
    <div class="row">
        <div class="col-md-12 text-center">
            <div class="logo ml-auto mr-auto mb-4"></div>
            <h1>Nichts gefunden!</h1>
            <h3>Hier geht's zurück zur <a href="/">Startseite.</a></h3>
        </div>
    </div>
</div>